//noScroll
class TabletAlert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    $(function(){
      if (window.matchMedia('(max-width: 830px) and (min-width:669px)').matches) {

        if( location.pathname === '/' ){

          let window_w = window.innerWidth;
          let window_h = window.innerHeight;
          const tabletAlertContent = document.querySelector(".js-tablet-alert")
          const closeBtn = document.querySelector(".js-tablet-close")

          if(window_w < window_h){
            const body = document.querySelector("body")
            const tabletAlert = document.querySelector(".js-tablet-alert")
            tabletAlert.classList.add("is-active")
            body.classList.add("is-fixed")
            closeBtn.addEventListener("click", () => {
            tabletAlertContent.classList.remove("is-active")
            })

          }
      }

    }})




  }
}
